var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { sdsCustomElement } from '../../utilities/custom-components';
import { SdsTreeCellBase } from './_sds-tree-cell-base';
import styles from './sds-tree-heading-cell.lit.scss';
/**
 * Represents a heading cell in a tree view.
 *
 * @tag sds-tree-heading-cell
 *
 * @fires sds.tree-heading-cell.border-mousedown - Fired when the left or right border is clicked.
 * The event object is of type [SdsTreeHeadingCellBorderMouseEvent](../../src/tree/cell/sds-tree-heading-cell.lit.ts), with details of the `x` position and `borderPlacement` ("left" or "right").
 * @fires sds.tree-heading-cell.border-mouseup - Fired when the left or right border is released.
 * The event object is of type [SdsTreeHeadingCellBorderMouseEvent](../../src/tree/cell/sds-tree-heading-cell.lit.ts), with details of the `x` position and `borderPlacement` ("left" or "right").
 */
let SdsTreeHeadingCell = (() => {
    var _SdsTreeHeadingCell_value_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-tree-heading-cell')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsTreeCellBase;
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    var SdsTreeHeadingCell = _classThis = class extends _classSuper {
        /**
         * Value of data cell
         * @attr
         */
        get value() { return __classPrivateFieldGet(this, _SdsTreeHeadingCell_value_accessor_storage, "f"); }
        set value(value) { __classPrivateFieldSet(this, _SdsTreeHeadingCell_value_accessor_storage, value, "f"); }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        render() {
            return html `
            ${this.renderInheritedStyles()}
            <div
                class="sds-tree__heading-left-border"
                part="sds-tree__heading-left-border"
                @mousedown="${(evnt) => this.dispatchBorderMouseDown('left', evnt.pageX)}"
                @mouseup="${(evnt) => this.dispatchBorderMouseUp('left', evnt.pageX)}"
            ></div>
            <div class="sds-tree__heading-cell" part="sds-tree-heading-cell">
                <slot></slot>
                <slot name="left"></slot>
                ${this.value}
                <slot name="right"></slot>
            </div>
            <div
                class="sds-tree__heading-right-border"
                part="sds-tree__heading-right-border"
                @mousedown="${(evnt) => this.dispatchBorderMouseDown('right', evnt.pageX)}"
                @mouseup="${(evnt) => this.dispatchBorderMouseUp('right', evnt.pageX)}"
            ></div>
        `;
        }
        connectedCallback() {
            super.connectedCallback();
        }
        disconnectedCallback() {
            super.disconnectedCallback();
        }
        dispatchBorderMouseDown(borderPlacement, x) {
            this.dispatchEvent(new CustomEvent(SdsTreeHeadingCell.BORDER_MOUSEDOWN_EVENT, { bubbles: false, composed: false, detail: { borderPlacement, x } }));
        }
        dispatchBorderMouseUp(borderPlacement, x) {
            this.dispatchEvent(new CustomEvent(SdsTreeHeadingCell.BORDER_MOUSEUP_EVENT, { bubbles: false, composed: false, detail: { borderPlacement, x } }));
        }
        constructor() {
            super(...arguments);
            _SdsTreeHeadingCell_value_accessor_storage.set(this, __runInitializers(this, _value_initializers, ''));
            __runInitializers(this, _value_extraInitializers);
        }
    };
    _SdsTreeHeadingCell_value_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsTreeHeadingCell");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _value_decorators = [property({ type: String })];
        __esDecorate(_classThis, null, _value_decorators, { kind: "accessor", name: "value", static: false, private: false, access: { has: obj => "value" in obj, get: obj => obj.value, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, _value_initializers, _value_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTreeHeadingCell = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.BORDER_MOUSEDOWN_EVENT = 'sds.tree-heading-cell.border-mousedown';
    _classThis.BORDER_MOUSEUP_EVENT = 'sds.tree-heading-cell.border-mouseup';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTreeHeadingCell = _classThis;
})();
export { SdsTreeHeadingCell };
